export enum CandidateTypeConstraints {
  BY_DOOR_OR_BEHIND_SWING = "BY_DOOR_OR_BEHIND_SWING",
  BY_DOOR = "BY_DOOR",
  BY_DOOR_BEHIND_SWING = "BY_DOOR_BEHIND_SWING",
  BY_CONVEX_CORNER = "BY_CONVEX_CORNER",
}
